import { getOrder } from './get-order';
export const hasOrderBeenCreated = () => !!getOrder();
//# sourceMappingURL=has-order-been-created.js.map